export default {
    SET_LOADING_STATE: "documentType/SET_LOADING_STATE",
    SET_DOCUMENT_TYPE_DATA: "documentType/SET_DOCUMENT_TYPE_DATA",
    SET_DIALOG_STATE: "documentType/SET_DIALOG_STATE",
    SET_ADD_DOCUMENT_TYPE_STATE: "documentType/SET_ADD_DOCUMENT_TYPE_STATE",
    SET_UPDATE_DOCUMENT_TYPE_STATE: "documentType/SET_UPDATE_DOCUMENT_TYPE_STATE"
}
